import React from "react";
import { Overlay, OverlayTrigger, Popover } from "react-bootstrap";

const ToolTip = ({ children, title, position = "right" }) => {
  return (
    <OverlayTrigger
      placement={position}
      overlay={
        <div className={"custom-tooltip p-" + position}>
          <div className="tooltip-inner">{title}</div>
        </div>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

const TextBox = ({ children, content, title, position = "right" }) => {
  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement={position}
      overlay={
        <Popover id="textbox-popover">
          {title && <Popover.Header as="h3">{title}</Popover.Header>}
          <Popover.Body>
            <div style={{ userSelect: "text", cursor: "text" }}>
              {content}
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

const PopOver = ({ children, title, position, target, isOpen, toggle }) => {
  return (
    <Overlay
      show={isOpen}
      target={target}
      placement={position}
      rootClose
      onHide={toggle}
    >
      {(props) => (
        <Popover id="popover-contained" {...props}>
          <Popover.Header as="h3">{title}</Popover.Header>
          <Popover.Body>{children}</Popover.Body>
        </Popover>
      )}
    </Overlay>
  );
};

export { ToolTip, TextBox, PopOver };
